import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceApiNestingale } from "../../axios";
export const saveProductThunk = createAsyncThunk(
    "product/saveProduct",
    async (config: { id: string, supplierId: any }, { rejectWithValue, getState }) => {
        const state = getState()
        try {
            let url = `v1/api/rawProducts`;
            let method = 'post';
            const methodHandlers = {
                post: axiosInstanceApiNestingale.post,
                put: axiosInstanceApiNestingale.put,
            };
            const productJson: any = Object.assign({}, (getState() as any).product?.product?.productData[0]);
            const key = config.id.split(".");
            const data = productJson[key[0]];
            const productId = productJson.productSkuId;
            if (productId) {
                url += `/${productId}`;
                method = 'put';
                delete productJson.productId;
            }

            //@ts-ignore
            const result = await methodHandlers[method](url, {[key[0]]:data},
                {
                    headers: {
                        'Supplier-Id': config?.supplierId,
                    }
                })
                .then((response: any) => {
                    return response.data
                }, (err: any) => {
                    const errorObj = Object.assign({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT" }, err)
                    console.log(errorObj);
                    throw errorObj;
                });
            console.log("Project saved :: ", result);
            // return templateId || result.templateId;
            return result;
        } catch (err) {
            console.log({ description: "NEST_SPA:Slices:saveProject:Exception", errorCode: "NEST_SPA:BUILDER_PAGE:SAVE_PROJECT", err_desc: (err as Error).message, err_stack: (err as Error).stack });
            return rejectWithValue(err);
        }
    }
);

export const fetchProductDataThunk = createAsyncThunk(
  'product/fetchProductData',
  async (config: any, { rejectWithValue }) => {
    const { productId, supplierId } = config;

    try {
      const response = await axiosInstanceApiNestingale.get(
        `v1/api/rawProducts/${productId}`,
        {
          headers: { 'Supplier-Id': supplierId },
          timeout: 10000,
        }
      );

      if (response.status !== 200) {
        return rejectWithValue(`Unexpected response: ${response.status}`);
      }

      const data = response.data;  // <-- ARRAY with 1 object

      if (!Array.isArray(data) || data.length === 0) {
        return rejectWithValue("No product data found");
      }

      const item = data[0]; // <-- First (and only) object

      // ------------------------------
      // ✅ Validate URL for single item
      // ------------------------------
      let isThreeDUrlValid = false;

      if (item?.threedImage) {
        try {
          const headResponse = await fetch(item.threedImage, { method: "HEAD" });
          isThreeDUrlValid = headResponse.ok;
        } catch (err) {
          isThreeDUrlValid = false;
        }
      }

      // Return back the same array, but with the extra flag
      const updatedArray = [
        {
          ...item,
          isThreeDUrlValid,
        }
      ];

      return updatedArray;

    } catch (error: any) {
      if (error.response) {
        return rejectWithValue(error.response.data?.message || 'Server error');
      } else if (error.request) {
        return rejectWithValue('No response from server. Please try again.');
      } else {
        return rejectWithValue(error.message || 'Something went wrong');
      }
    }
  }
);

